import { render } from "./SFormBuilder.vue?vue&type=template&id=720a637d&scoped=true&ts=true"
import script from "./SFormBuilder.vue?vue&type=script&lang=ts"
export * from "./SFormBuilder.vue?vue&type=script&lang=ts"

import "./SFormBuilder.vue?vue&type=style&index=0&id=720a637d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720a637d"]])

export default __exports__